import EventBus from "eventbusjs";

const KEYS = {
  fontSizeChanged: "fontSizeChanged",
  conversationList: "conversationList",
  histroyMessage: "histroyMessage",
  preScrollToCommentsList: "preScrollToCommentsList",
  refreshContent: "refresh_staticWebContent"
};

const addEventListener = EventBus.addEventListener.bind(EventBus);
const removeEventListener = EventBus.removeEventListener.bind(EventBus);
const dispatch = EventBus.dispatch.bind(EventBus);

export default {
  // EventBus.addEventListener(type, callback, scope)
  addEventListener,
  // EventBus.removeEventListener(type, callback, scope)
  removeEventListener,
  // EventBus.dispatch(type, target, args ...)
  dispatch,
  KEYS
};



// WEBPACK FOOTER //
// ./src/utils/foBus.js